module.exports = __webpack_public_path__ + "img/img4.252d295e.jpg";